enum OAuthStep {
  LANDING_PAGE = 1,
  SIGN_IN,
  SIGN_UP,
  EXTERNAL_APPLICATION,
  CERTIFICATION,
  ACCOUNT_TYPE,
  PAYMENT,
  AUTHORIZATION,
}

export { OAuthStep };
